import { createServiceDetailsQuery } from '@hcr/api/optimizely'

import { HTTP_CONFIG } from '../../../../configs'

export const useServiceDetailsQuery = createServiceDetailsQuery(HTTP_CONFIG.API.Optimizely.url)
